<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :visible.sync="disvisible"
    @close="handleClose"
  >
    <!-- 图片分类 -->
    <el-form
      v-if="showType === 0"
      :model="form"
      :rules="rules"
      ref="formRef"
      label-width="100px"
    >
      <el-form-item label="选择类型" prop="mealType">
        <el-radio-group v-model="form.mealType" @change="changeType">
          <el-radio
            v-for="item in typeItems"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item
        v-if="form.mealType == 1 || form.mealType == 4"
        label="首页推荐"
        prop="isHome"
      >
        <el-switch
          :inactive-value="0"
          :active-value="1"
          v-model="form.isHome"
        ></el-switch>
      </el-form-item>
      <el-form-item
        v-if="form.mealType == 4 && form.isHome"
        label="上传封面"
        prop="homePicture"
      >
        <el-upload
          :action="action"
          :headers="headers"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-progress="handleProgress"
          list-type="picture-card"
          accept=".png, .jpg, .jpeg"
          :file-list="fileList"
          ref="upload"
        >
          <i slot="default" class="el-icon-plus"></i>
        </el-upload>
        <div class="el-upload__tip" style="line-height: 1">
          支持上传一张小于2M的 png/jpg/jpeg文件
        </div>
      </el-form-item>

      <el-form-item
        v-if="form.mealType == 1"
        label="图片页面推荐"
        prop="imagePageRecommend"
      >
        <el-switch
          :inactive-value="0"
          :active-value="1"
          v-model="form.isPicture"
        ></el-switch>
      </el-form-item>
    </el-form>
    <!-- 节庆热点 -->
    <el-form
      v-else-if="showType === 1"
      :model="form2"
      :rules="rules"
      ref="formRef"
      label-width="100px"
    >
      <el-form-item label="节庆名称" prop="name">
        <el-input v-model="form2.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="日期" prop="date">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="form2.date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="图片页面推荐" prop="isPicture">
        <el-switch
          :inactive-value="0"
          :active-value="1"
          v-model="form2.isPicture"
        ></el-switch>
      </el-form-item>
    </el-form>
    <!-- 图片标签 -->
    <el-form
      v-else-if="showType === 2"
      :model="form3"
      :rules="rules"
      ref="formRef"
      label-width="100px"
    >
      <el-form-item label="选择类型" prop="mealType">
        <el-radio-group v-model="form3.mealType" @change="changeType">
          <el-radio
            v-for="item in typeItems"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标签名称" prop="name">
        <el-input v-model="form3.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item
        v-if="form3.mealType === 1"
        label="图片页面推荐"
        prop="isPicture"
      >
        <el-switch
          :inactive-value="0"
          :active-value="1"
          v-model="form3.isPicture"
        ></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="handleSubmit"
        >确定</el-button
      >
    </span>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { fileUp, fileEcho } from "@/api/url";
export default {
  name: "CategoryDialog",
  props: {
    showType: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "add",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    disvisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {
      action: fileUp + "?keepActive=true&originalProxy=fullText",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      dialogImageUrl: "",
      dialogVisible: false,
      form: {
        name: "",
        isHome: 0,
        isPicture: 0,
        mealType: 1,
        homePicture: "",
      },
      form2: {
        name: "",
        date: "",
        isPicture: 0,
      },
      form3: {
        name: "",
        isPicture: 0,
        mealType: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        date: [{ required: true, message: "请选择日期", trigger: "blur" }],
        mealType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        homePicture: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
      },
      typeItems: [
        {
          label: "图片",
          value: 1,
        },
        {
          label: "音频",
          value: 2,
        },
        {
          label: "视频",
          value: 3,
        },
        {
          label: "知识库",
          value: 4,
        },
      ],
      fileList: [],
    };
  },
  watch: {
    data: {
      handler(newValue) {
        this.fileList = [];
        if (this.mode === "edit") {
          if (this.showType === 0) {
            this.form = {
              ...newValue,
              homePicture: newValue.homePicture || "",
            };
          } else if (this.showType === 1) {
            this.form2 = { ...newValue };
          } else if (this.showType === 2) {
            this.form3 = { ...newValue };
          }
          if (this.form.homePicture) {
            this.fileList = [
              {
                name: this.form.name,
                url: this.form.homePicture,
              },
            ];
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      if (fileList.length) return;
      this.form.homePicture = "";
      this.fileList = [];
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleProgress(event, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    beforeUpload(file) {
      console.log(file);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }

      return isLt2M;
    },
    handleSuccess(res, file) {
      if (res) {
        this.form.homePicture = fileEcho + "/" + res.path;
        this.fileList = [
          {
            name: file.name,
            url: fileEcho + "/" + res.path,
          },
        ];
      } else {
        this.$message.error("上传失败");
        this.$refs.upload.clearFiles();
      }
    },
    changeSwitch(v) {
      console.log(v);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeType(v) {
      this.form.isHome = 0;
      this.form.isPicture = 0;
      this.form3.isPicture = 0;
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.showType === 0) {
            this.$emit("confirm", this.form);
          } else if (this.showType === 1) {
            this.$emit("confirm", this.form2);
          } else if (this.showType === 2) {
            this.$emit("confirm", this.form3);
          }
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    handleCancel() {
      this.resetForm();
      this.disvisible = false;
      // this.$emit("update:visible", false);
    },
    handleClose() {
      this.resetForm();
      this.disvisible = false;
      // this.$emit("update:visible", false);
    },
    resetForm() {
      if (this.showType === 0) {
        this.form = {
          name: "",
          isHome: 0,
          isPicture: 0,
          mealType: 1,
          homePicture: "",
        };
      } else if (this.showType === 1) {
        this.form2 = {
          name: "",
          date: "",
          isPicture: 0,
        };
      } else if (this.showType === 2) {
        this.form3 = {
          name: "",
          isPicture: 0,
          type: 1,
        };
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    show(type, row) {
      //this.visible = true
      this.type = type;

      if (type === "add") {
        this.resetForm();
      } else if (type === "edit") {
        this.form = JSON.parse(JSON.stringify(row));
      }
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
